import { useCoinById } from '../../../api';
import { useWithdrawSearchParams } from '../useWithdrawSearchParams';

/**
 * Custom hook to retrieve the coin information by its ID from the withdrawal search parameters.
 * This hook uses the coin ID from the search parameters and fetches the corresponding coin information.
 *
 * @returns {Object} An object containing the coin information.
 *
 * @example
 * // Usage example:
 * const { data, error, isLoading } = useWithdrawalCoinBySearchParamId();
 */
export function useWithdrawalCoinBySearchParamId() {
  // Retrieve the coin ID from the search parameters
  const { coinId } = useWithdrawSearchParams();

  // Fetch the coin information by its ID using the useCoinById hook
  return useCoinById({
    id: coinId?.toString(), // Convert the coin ID to a string
  });
}
